import { ApiKeys } from './ApiKeys'
import { connect } from 'react-redux'

const mapStateToProps = state => ({ activeBot: state.activeBot })

export default connect(mapStateToProps)(ApiKeys)
